import styled from "styled-components";

export const MainContainer = styled.section`
  //width: 300px;
  height: auto;
  border-left: 4px solid #fff;
  padding: 20px 0px 20px 20px;
  position: relative;
  /* @media (max-width: 430px) {
    padding: 20px 0px 20px 0px;
  }
  @media (max-width: 400px) {
    width: 300px;
  } */
`;

export const DotContainer = styled.div`
  position: absolute;
  top: 0;
  left: -13px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const DotLabel = styled.span`
  font-size: 12;
  color: #fff;
`;

export const Dot = styled.div`
  margin-right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 15px;
  background-color: #fff;
`;

export const Text = styled.p`
  font-size: 18px;
  text-align: justify;
  padding-right: 5px;
  //width: 450px;
  color: #fff;
  /* @media (max-width: 430px) {
    //width: 300px;
  }
  @media (max-width: 400px) {
    width: 280px;
  } */
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
  flex-direction: column;
  margin: 10px 0;
  padding-right: 10px;

  /* @media (max-width: 430px) {
    align-items: center;
  } */
  @media (min-width: 570px) {
    flex-direction: row;
  }
  @media (min-width: 885px) {
    flex-direction: column;
  }
  @media (min-width: 1200px) {
    flex-direction: row;
  }
`;

export const ImageContainer = styled.div`
  min-width: 150px;
  min-height: 120px;
  background-color: #fff;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  @media (min-width: 500px) {
    min-width: inherit;
    min-height: inherit;
    margin-right: 10px;
  }
`;
